// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2G821","unreadBadge":"styles_unreadBadge__eqxfJ","modalContent":"styles_modalContent__30p8Q","modal":"styles_modal__VmUgi"};